import { ModalTypes } from 'store/UI/UITypes'

export const openedModalsStack: Array<{
  modalType: ModalTypes
  modalProps: any
}> = []
